import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDateRangeRequestParams } from "Dashboard/domain/IDateRangeRequestParams";
import { RootState } from "reducers";
import { IResourceCharge } from "../domain/IResourceCharge";
import { DailyTableService } from "../services/dt.service";

interface dtBilledResourcesState {
  loading: boolean;
  charges: IResourceCharge[];
  error: any;
}

const initialState: dtBilledResourcesState = {
  loading: false,
  charges: [],
  error: undefined,
};

export const getBasicDataForChargesOfResources = createAsyncThunk(
  "DailyTable/getBasicDataForChargesOfResources",
  async (data?: IDateRangeRequestParams) => {
    try {
      const result = await DailyTableService.getBasicDataForChargesOfResources(
        data
      );
      return result.charges;
    } catch (err) {
      setError(err);
    }
  }
);

export const dtBilledResourcesSlice = createSlice({
  name: "Charges",
  initialState: initialState,
  reducers: {
    setBilledResources: (state, action: PayloadAction<IResourceCharge[]>) => {
      state.charges = action.payload;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBasicDataForChargesOfResources.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getBasicDataForChargesOfResources.fulfilled,
      (state, action) => {
        state.charges = action.payload ? action.payload : [];
        state.loading = false;
      }
    );
    builder.addCase(
      getBasicDataForChargesOfResources.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    );
  },
});

export const selectState = (state: RootState) => state.dailytable.charges;

export const { setError } = dtBilledResourcesSlice.actions;

export default dtBilledResourcesSlice.reducer;
